// react
import { Map, List, fromJS } from "immutable";

// config
import Config from "Config";

// utils
import uuid from "Utils/uuid";

export const initialState = Map({
	active: List(),
});

export default function notificationsState(state = initialState, action) {
	switch (action.type) {
		case "NOTIFICATION:ERROR": {
			const notification = fromJS({
				key: uuid(),
				message: action.message,
				action: action.actionMessage,
				dismissAfter: 5000,
				barStyle: {
					color: "#fff",
					backgroundColor: Config.colors.red,
				},
				actionStyle: {
					backgroundColor: "rgba(255, 255, 255, 0.15)",
					color: "rgba(255, 255, 255, 0.75)",
				},
			});

			return state.updateIn(["active"], List(), (list) => list.push(notification));
		}

		case "[100] create info toast": {
			const notification = fromJS({
				key: uuid(),
				message: action.message,
				action: action.actionMessage,
				dismissAfter: 5000,
				barStyle: {
					color: "#fff",
					backgroundColor: Config.colors.blue,
				},
				actionStyle: {
					backgroundColor: "rgba(255, 255, 255, 0.15)",
					color: "rgba(255, 255, 255, 0.75)",
				},
			});

			return state.updateIn(["active"], List(), (list) => list.push(notification));
		}

		case "NOTIFICATION:UPDATE": {
			return state.setIn(["active"], action.notifications);
		}

		default:
			return state;
	}
}
